export default {
  computed: {
    steps() {
      const steps = [];

      steps.push({ name: 'auth.identification' });

      steps.push({ name: 'auth.confirmation' });

      return steps;
    },
  },
};
